export default "__VITE_ASSET__DnXKhmRp__"